"use client";
import { jsxs as n, jsx as l } from "react/jsx-runtime";
const s = ({
  title: i,
  titleId: a,
  desc: d,
  descId: e,
  ...r
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-vn",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": e,
    ...r,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: e, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "vn-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-85.3 0h682.6v512H-85.3z" }) }) }),
      /* @__PURE__ */ n(
        "g",
        {
          fillRule: "evenodd",
          clipPath: "url(#vn-a)",
          transform: "translate(80)scale(.9375)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#da251d", d: "M-128 0h768v512h-768z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#ff0",
                d: "M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  s as default
};
